import React, { useEffect, useRef, useState } from "react";
import classes from "./ZipEditProfileModal.module.css";
import { AnimatePresence, motion } from "framer-motion";
import { FaXmark, FaTrash, FaUpload, FaUser } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { zipUserProfileEditApi } from "../../http/http";

const ZipEditProfileModal = ({
    modal,
    setModal,
    name,
    image,
    fetchUserProfile
}) => {

    const {t}=useTranslation();

    const [saveLoading, setSaveLoading] = useState(false);

    const { userZip } = useSelector(
        (state) => state?.persisted?.userZipGameTokenSlice
    );

    const [state, setState] = useState({
        name: "",
        image: null,
    });

    const [pickedImage, setPickedImage] = useState("");
    const imageInput = useRef();

    useEffect(() => {
        if (modal) {
            setState({ name: name, image: image })
        }
    }, [modal]);

    useEffect(() => {
        if (modal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [modal]);

    const handlePickClick = () => {
        imageInput.current?.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            setPickedImage("");
            setState((prev) => ({ ...prev, image: null }));
            return;
        }

        const fileReader = new FileReader();

        fileReader.onload = () => {
            setPickedImage(fileReader.result);
        };

        fileReader.readAsDataURL(file);
        setState((prev) => ({ ...prev, image: file }));
    };

    const handleRemoveImage = () => {
        setPickedImage("");
        setState((prev) => ({ ...prev, image: null }));
        if (imageInput.current) {
            imageInput.current.value = "";
        }
    };

    const submitHandler = async (e) => {
        try {
            e.preventDefault();
            setSaveLoading(true);

            const formData = new FormData();
            formData.append("name", state?.name);

            if (state?.image) {
                formData.append("file", state.image);
            }
            await zipUserProfileEditApi(formData, userZip?.token);
            await fetchUserProfile();
            toast.success(t("240"));
            setModal(false);

        } catch (error) {
            toast.error(t("86"));
        } finally {
            setSaveLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {modal && (
                <motion.div
                    className={classes.modalOverlay}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setModal(false)}
                >
                    <motion.div
                        className={classes.modalBox}
                        initial={{ opacity: 0, y: 30, scale: 0.94 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.96 }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className={classes.closeBtn} onClick={() => setModal(false)} type="button">
                            <FaXmark />
                        </button>

                        <div className={classes.modalHeader}>
                            <h2 className={classes.modalTitle}>{t("241")}</h2>
                            <p className={classes.modalSubTitle}>
                                {t("242")}
                            </p>
                        </div>

                        <form
                            onSubmit={submitHandler}
                            className={classes.form}
                            encType="multipart/form-data"
                        >
                            <div className={classes.editAvatarSection}>
                                <div className={classes.avatarImageContainer}>
                                    {image || pickedImage ?
                                        <img
                                            src={pickedImage ?? image}
                                            alt="profile pic"
                                            className={classes.avatarImage}
                                        /> : <div className={classes.avatarImage}>
                                            <p className={classes.avatarImageText}>{t("243")}</p>
                                        </div>
                                    }

                                    {(pickedImage || image) && (
                                        <button
                                            type="button"
                                            className={classes.badge}
                                            onClick={handleRemoveImage}
                                        >
                                            <FaTrash className={classes.trashIcon} />
                                        </button>
                                    )}
                                </div>

                                <div className={classes.uploadActions}>
                                    <input
                                        className={classes.input}
                                        type="file"
                                        id="image"
                                        accept="image/png, image/jpeg, image/jpg, image/webp"
                                        name="file"
                                        ref={imageInput}
                                        onChange={handleImageChange}
                                    />

                                    <button
                                        className={classes.button}
                                        type="button"
                                        onClick={handlePickClick}
                                    >
                                        <FaUpload className={classes.uploadIcon} />
                                        {t("244")}
                                    </button>
                                </div>
                            </div>

                            <div className={classes.userDetailsContainer}>
                                <label className={classes.userNameLabel}>{t("245")}</label>

                                <div className={classes.inputWrap}>
                                    <FaUser className={classes.inputIcon} />
                                    <input
                                        type="text"
                                        className={classes.userNameInput}
                                        name="name"
                                        placeholder={t("246")}
                                        value={state.name}
                                        onChange={(event) =>
                                            setState({ ...state, name: event.target.value })
                                        }
                                    />
                                </div>

                                <div className={classes.actionRow}>
                                    <button
                                        className={classes.cancelBtn}
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        {t("247")}
                                    </button>

                                    <button className={classes.saveChangesBtn} type="submit">
                                        {saveLoading ? t("248") : t("249")}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ZipEditProfileModal;